import axios from '../axios';
import * as models from './models';

export function Quotes(hyejooRequestInit: models.IHyejooRequest): Promise<models.QuotesHyejooResponse> {
    return axios.get('/v2/quotes', {
        params: new models.HyejooRequest(hyejooRequestInit),
    }).then(r => models.QuotesHyejooResponse.fromJSON(r.data));
}

// QuoteHeardAboutUsAnswered reports whether the quote's customer already told
// us how they heard about us. Only the quote key authorizes it.
export function QuoteHeardAboutUsAnswered(quoteKey: string): Promise<boolean> {
    return axios.get(`/quotes/${quoteKey}`, { params: { data: 'id,heardAboutUsAnswered' } }).
        then(r => Boolean(models.QuoteGetResponse.fromJSON(r.data).quote.heardAboutUsAnswered));
}

// NewQuoteHeardAboutUs records the quote-received page's "how did you hear
// about us" answer against the quote's customer, authorized by the quote key.
// The server keeps a customer's first answer, so a repeat submit is a no-op.
export function NewQuoteHeardAboutUs(quoteKey: string, answerInit: models.IHeardAboutUsAnswer): Promise<void> {
    return axios.post(`/quotes/${quoteKey}/heard-about-us`, new models.HeardAboutUsAnswer(answerInit)).then(() => undefined);
}
